/**
 * Feel free to use this file if you need javascript that is only
 * supposed to load on the front-end with your block.
 *
 * For instance, this can be handy if you want to add some interaction or slider
 * functionality not appropriate for the editor experience.
 */

const accordions = document.querySelectorAll( '.wp-block-qala-blocks-single-accordion' );

accordions.forEach( accordion => {
	const togglePanel = accordion.querySelector( '.wp-block-qala-blocks-single-accordion__heading' );
	const panel = accordion.querySelector( '.wp-block-qala-blocks-single-accordion__content' );
	const multiAccordionParent = accordion.closest( '.wp-block-qala-blocks-multi-image-accordions' );
	if ( multiAccordionParent ) {
		// This blocked is used inside the Multi Image Accordions block
		const accordionImage = accordion.querySelector( '.accordion-image-placeholder img' );
		if ( accordionImage ) {
			accordionImage.classList.add( 'multi-accordion-image-hidden' );
			const imageWrap = multiAccordionParent.querySelector( '.multi-image-accordions__image-wrap' );
			imageWrap.appendChild( accordionImage );
		}
	}
	togglePanel.addEventListener( 'click', function() {
		accordion.classList.toggle( 'active' );
		if ( panel.style.maxHeight ) {
			panel.style.maxHeight = null;
		} else {
			panel.style.maxHeight = `${ panel.scrollHeight }px`;
		}
	} );
} );
